/**
 * SponsorsStrip - Componente compartido de patrocinadores
 * 501 Dart League Web
 * 
 * Usado en: JesusSalateTraining, X01Game
 */

import React from 'react';
import patrocinio1 from '../../assets/patrocinio1.jpg';
import patrocinio2 from '../../assets/patrocinio2.jpg';
import triple17 from '../../assets/triple17.png';
import triple17yeyo from '../../assets/Triple17yeyo2.png';
import logoDani from '../../assets/logoDani.png';
import logoPrima from '../../assets/LogoPrima.png';
import Cad from '../../assets/Cad.jpg';
import Lokyo from '../../assets/Lokyo.jpg';
import Cocktails from '../../assets/Cocktails.jpg';
import KingDart from '../../assets/KingDart.jpg';
import LogoRocha from '../../assets/LogoRocha.png';
import CollaboratorsSection from './CollaboratorsSection';
import './styles/sponsors.css';


const SPONSORS = [
  { href: 'https://www.instagram.com/lokkyokopas2/', img: Lokyo, name: 'Lokkyo Kopas' },
  { href: 'https://www.instagram.com/kingdartleague/', img: KingDart, name: 'Kings Dart League' },
  { href: 'https://www.instagram.com/triple_17_dartshop/', img: triple17yeyo, name: 'Triple 17', logoClassName: 'sponsor-item-logo--triple17' },
  { href: 'https://www.instagram.com/club.dardos.pizarra/', img: patrocinio1, name: 'C.D. Pizarra' },
  { href: 'https://www.instagram.com/salaalexs/', img: patrocinio2, name: "Sala Alex's", logoClassName: 'sponsor-item-logo--large' },
  { href: 'https://www.instagram.com/recreativos_triple17/', img: triple17, name: 'Recreativos Triple 17', logoClassName: 'sponsor-item-logo--triple17' },
  { href: 'https://www.instagram.com/creadoaldetalle/', img: Cad, name: 'CREADO AL DETALLE', logoClassName: 'sponsor-item-logo--large' },
  { href: 'https://www.instagram.com/clubdedardos_cocktails/', img: Cocktails, name: 'Cocktails', logoClassName: 'sponsor-item-logo--cocktails' },
  { href: 'https://www.instagram.com/bar_de_copas_rocha/', img: LogoRocha, name: 'Bar de Copas Rocha', logoClassName: 'sponsor-item-logo--rocha' },
  { href: 'https://www.escobarmultitransportes.es/', img: logoPrima, name: 'Escobar Multitransportes', logoClassName: 'sponsor-item-logo--large' },
  { href: 'https://wa.me/34656820537', img: logoDani, name: 'Daniel Berlanga', logoClassName: 'sponsor-item-logo--large' },
];

const getSponsorLogoClassName = (sponsor) => [
  'sponsor-item-logo',
  sponsor.logoClassName,
].filter(Boolean).join(' ');

const SponsorsStrip = () => (
  <div className="sponsors-strip">
    <CollaboratorsSection titleClassName="sponsors-label" />
    <span className="sponsors-label">Patrocinadores</span>
    <div className="sponsors-scroll">
      {SPONSORS.map((s, i) => (
        <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="sponsor-item">
          <img
            src={s.img}
            alt={s.name}
            className={getSponsorLogoClassName(s)}
          />
          <span className="sponsor-name">{s.name}</span>
        </a>
      ))}
    </div>
    <p className="sponsors-cta">
      ¿Quieres ser patrocinador?{' '}
      <a href="https://wa.me/34627367531?text=Hola,%20estoy%20interesado%20en%20ser%20patrocinador%20de%20501%20Darts" target="_blank" rel="noopener noreferrer">
        Contáctanos
      </a>
    </p>
  </div>
);

export default SponsorsStrip;
